<template>
  <div class="col95 colSm95 row center" style="font-size:1rem;">
    
    <div class=" block tCenter glass" style="width:100%;line-height:40px;padding:0px;overflow:hidden;background:rgba(256,256,256,0.8);min-height:80dvh;">
      
      <!--
        <div class="orange fullWidth" style="width:100%;" v-if="cursoData.c3=='L'">
          {{cursoData.c3}}
          
        </div>
      -->
      <div :class="cursoData.c3=='P'?'primaryBg':'orange'+' fullWidth'" style="width:100%;">
        {{
        cursoData.c3=='L'?'EN LÍNEA':
        cursoData.c3=='P'?'PRESENCIAL':''        
        }}

        <button class="btnDefault left" @click="vista=''" style="width:8dvw;" v-if="vista!=''">
          <i class="bi bi-arrow-left"></i>
        </button>
        
        <button class="btnError right" @click="userStore.selectedCursoHome=null;" style="width:8dvw;">
          <i class="bi bi-x-lg"></i>
        </button>

      </div>


      <section v-if="vista==''">

        <div class="col20 row colSm100 rowm tLeft" style="margin-top: 0px;padding:0px;" >
  
          <div class="fullWidth" style="display: flex;">
            <!--
            width:250px;
            -->
            <img :src="cursoData.c34" style="object-fit:cover;height:130px;vertical-align: top;">
            <div class="colSm50 rowm hideDesktop" style="vertical-align: top;margin:0px;flex-grow:1;">
              <div class="fullWidth">
                <div :class="cursoData.c3=='P'?'primaryBg':'orange'+' tCenter'" style="flex-grow:1;">
                  <h4 style="margin:0px;vertical-align: top;" @dblclick="showCursoData=!showCursoData;">
                    Grupo: {{cursoData.c39}}
                  </h4>
                </div>
                <div class="col95 block tCenter" style="line-height:1;margin-bottom:5px;flex-grow:1;">
                  <small style="color:gray;">
                    <i class="bi bi-person-vcard"></i>{{cursoData.c35}}
                  </small>
                </div>
              </div>
    
            </div>
  
          </div>
  
        </div>
  
        <div class="col50 row colSm100 rowm tCenter" style="margin:0 auto;margin-top:0px;">
          <div>
            <h4 style="color:var(--blueDark);margin-bottom:0px;margin-top:0px;">
              {{cursoData.c2}}
            </h4>
          </div>
  
          <div class="col95 colSm100 rowm">
            <div class="col95 center">              
              <div style="line-height: 18px;">
                Del {{$root.fechaToStr(''+cursoData.c20)}} al {{$root.fechaToStr(''+cursoData.c21)}}
              </div>
              <div class="col95 row colSm95" style="margin-top:3px;">
                <div class="hideMobile">
                  <div v-if="cursoData.c5!=''">
                    Lunes: 
                    <strong>
                      {{cursoData.c5}} - {{cursoData.c6}}
                    </strong>
                  </div>
                  <div v-if="cursoData.c7!=''">
                    Martes: 
                    <strong>
                      {{cursoData.c7}} - {{cursoData.c8}}
                    </strong>
                  </div>
                  <div v-if="cursoData.c9!=''">
                    Miércoles:
                    <strong>
                      {{cursoData.c9}} - {{cursoData.c10}}
                    </strong>
                  </div>
                  <div v-if="cursoData.c11!=''">
                    Jueves:
                    <strong>
                      {{cursoData.c11}} - {{cursoData.c12}}
                    </strong>
                  </div>
                  <div v-if="cursoData.c13!=''">
                    Viernes:
                    <strong>
                      {{cursoData.c13}} - {{cursoData.c14}}
                    </strong>
                  </div>
                  <div v-if="cursoData.c15!=''">
                    Sábado:
                    <strong>
                      {{cursoData.c15}} - {{cursoData.c16}}
                    </strong>
                  </div>
                  <div v-if="cursoData.c17!=''">
                    Domingo:
                    <strong>
                      {{cursoData.c17}} - {{cursoData.c18}}
                    </strong>
                  </div>
                </div>
                <div class="hideDesktop colSm95 rowm" style="line-height: 15px;">
                  
                  <div class="colSm48 row">
                    <div v-if="cursoData.c5!=''">
                      Lunes: 
                      <strong>
                      {{cursoData.c5}} - {{cursoData.c6}}
                    </strong>
                    </div>
                    <div v-if="cursoData.c7!=''">
                      Martes: 
                      <strong>
                        {{cursoData.c7}} - {{cursoData.c8}}
                      </strong>
                    </div>
                    <div v-if="cursoData.c9!=''">
                      Miércoles:
                      <strong>
                        {{cursoData.c9}} - {{cursoData.c10}}
                      </strong>
                    </div>
                    <div v-if="cursoData.c11!=''">
                      Jueves:
                      <strong>
                        {{cursoData.c11}} - {{cursoData.c12}}
                      </strong>
                    </div>
                  </div>
                  <div class="colSm48 row" style="margin-left:5px;">
                    <div v-if="cursoData.c13!=''">
                      Viernes:
                      <strong>
                        {{cursoData.c13}} - {{cursoData.c14}}
                      </strong>
                    </div>
                    <div v-if="cursoData.c15!=''">
                      Sábado:
                      <strong>
                        {{cursoData.c15}} - {{cursoData.c16}}
                      </strong>
                    </div>
                    <div v-if="cursoData.c17!=''">
                      Domingo:
                      <strong>
                        {{cursoData.c17}} - {{cursoData.c18}}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--
            <div>
              <label style="color:gray;line-height:5px;">
                <strong>
                  ${{cursoData.c21}}
                  <span 
                  style="              
                  color:black;
                  display:block;
                  position:relative;
                  left:0;
                  top:-30px;
                  right:0;
                  z-index:200;
                  ">
                    __________
                  </span>
                </strong>
              </label>
              <label style="color:black;line-height:5px;">
                ${{cursoData.c11}}
              </label>
            </div>
          -->

          <div class="col95 hideMobile" style="line-height:1;margin-bottom:5px;">
              <small style="color:gray;">
                <i class="bi bi-person-vcard"></i>{{cursoData.c35}}
              </small>          
          </div>
          
        </div>
  

        

        <div :class="'col30 row '+(cursoData.c3=='P'?'primaryBg':'orange')+' hideMobile'">
            <h4 style="margin-bottom:0px;margin-top:0px;" @dblclick="showCursoData=!showCursoData;">
              Grupo: {{cursoData.c39}}
            </h4>
        </div>
      </section>


      <div class="col95 center colSm95" style="margin-top:20px;">

        <section v-if="vista!==''">

          <article v-if="vista=='APORTACIONES'">

             <div>
               <strong>
                 Aportaciones del Alumno:
               </strong>
             </div>
             <div>

              <div class="col90 center">

                <button class="btnDefault col48 row colSm100" @click="getReferenciaStr()">
                  <i class="bi bi-currency-dollar"></i>
                  <i class="bi bi-card-list"></i>
                  <small>
                    Descargar Referencia
                  </small>
                </button>

                

                <button class="btnBlue col48 row colSm100">
                  
                  <strong>
                    <i class="bi bi-currency-dollar"></i>
                    <i class="bi bi-upload"></i>
                  </strong>

                  <label class="tCenter" :for="'comprobanteTotal'" style="cursor:pointer;" v-if="cargando==0">
                    <small>
                      <b>
                        Cargar Comprobante de aportación
                      </b>
                    </small>
                  </label>
                  <input 
                    class="form-control" 
                    type="file" 
                    :name="'comprobanteTotal'" 
                    :id="'comprobanteTotal'" 
                    :ref="'comprobanteTotalRef'" 
                    v-on:change="handleFileDoc('aportacion','.jpg','comprobanteTotal',false,'-')" 
                    accept=".jpg,.jpeg" 
                    v-bind:value="fileName"
                  />
                  <small v-if="cargando==1">
                    Cargando
                  </small>

                </button>                                
                
                <!--
                  <button class="btnDefault col98 row colSm100" @click="sendGenComprobantePago()">
                    Generar Comprobante
                  </button>
                -->
                
              </div>

              <div class="col95 center">

                <div>
                  Lista de Aportaciones: 
                  <strong>
                    {{listaAportaciones.length}}
                  </strong>
                </div>

                <section class="center fullWidth" style="overflow-y:auto;min-height:45dvh;max-height:40dvh;">

                  <article class="glass1 col45 row colSm100" v-for="(aportacion,aI) in listaAportaciones" :key="aportacion" style="margin:10px;">
                    <div class="tLeft center col80">
                      {{aI+1}} | 
                      <strong style="color:var(--blueDark);">
                        {{aportacion.c3}}
                      </strong>
                    </div>
  
                    <div>
                      <small>
                        Fecha de Registro: 
                      </small>
                       {{aportacion.c2}}
                    </div>
  
                    <div>
                      <small>
                        Banco: 
                      </small>
                       <strong style="color:var(--orange);">
                         {{aportacion.c2}}
                       </strong>
                    </div>
  
                    <div>
                       Monto: 
                       <strong>
                         ${{aportacion.c4}}
                       </strong>
                    </div>

                    <div :class="getObservacionClass(aportacion.c6)" style="border-radius: 25px;overflow:hidden;">
                      <strong>
                        Observación:
                      </strong>
                      <div>
                        {{aportacion.c5}}
                      </div>

                      <!--
                       v-if="aportacion.c6=='O'"
                      -->

                      <div v-if="aportacion.c6=='O'">

                        <!--
                          Refs:
                          |{{ $refs['070975bf6add0dbafec72ad22Ref']}}|
                        -->

                        <button class="btnBlue col49 row colSm100">
                          <strong>
                            <i class="bi bi-currency-dollar"></i>
                            <i class="bi bi-upload"></i>
                          </strong>

                          <label class="tCenter" :for="'comp'+aI" style="cursor:pointer;" v-if="cargando==0">
                            <small>
                              <b>
                                Cargar Comprobante de aportación
                              </b>
                            </small>
                          </label>
                          <input 
                            class="form-control" 
                            type="file" 
                            :name="'comp'+aI" 
                            :id="'comp'+aI" 
                            :ref="'comp'+aI+'Ref'" 
                            v-on:change="handleFileDoc('aportacion','.jpg','comp'+aI,true,''+aportacion.c0)" 
                            accept=".jpg,.jpeg" 
                            v-bind:value="fileName"
                          />
                          <small v-if="cargando==1">
                            Cargando
                          </small>
                        </button>

                      </div>


                    </div>


                  </article>
                  
                  <div class="col45 row" style="min-height:50px;margin:10px;">
                    <span>
                    </span>
                  </div>

                  <div style="min-height:50px;">
                    <span>
                    </span>
                  </div>

                </section>


              </div>


             </div>

            

          </article>

          <article v-if="vista=='ENCUESTA'">

            <registro-encuesta :cursoData="cursoData" @closeAccionEv="closeVista" @updateEstadoEncuestaEv="updateEstadoEncuesta">
            </registro-encuesta>

          </article>

        </section>


        <section class="col80 tLeft block center" v-if="vista==''">
          <!--
            <div class="btn btnOrange col50 row" @click="setSelected()">
              <i class="bi bi-file-earmark-text-fill"></i>
              <small>
                Ver Contenido del Curso
              </small>
            </div>
          -->

          <!--
            <div class="btn btnBlue col50 row" @click="setSelected()">
              <i class="bi bi-question-circle-fill"></i>
              <small>
                Preguntas Frecuentes
              </small>
            </div>
          -->
          <!--
            <div class="btn btnBlue fullWidth row" style="margin-top:5px;">
              &nbsp;1| <i class="bi bi-clipboard-data"></i>Ver Estado del Curso
              <div>
                <small>
                  Aqui puedes verificar cuando comienza el curso.
                </small>
              </div>
            </div>
          -->
          <div v-if="showCursoData">
            <div style="overflow-y: auto;max-height:20dvh;min-height:25dvh;">
              {{ cursoData }}
            </div>
          </div>

          <section v-if="cursoData.c41!='C'">

            <div class="btn btnBlue fullWidth row" style="margin-top:5px;" @click="vista='APORTACIONES'"  v-if="cursoData.c40==1">
              &nbsp;1 | <i class="bi bi-currency-dollar"></i>
              <strong>
                Aportaciones
              </strong>
              <div>
                <small>
                  Aqui puedes descargar tu referencia de aportación y cargar tus comprobantes.
                </small>
              </div>
            </div>
  
            <div class="btn btnDefault fullWidth row" style="margin-top:5px;" @click="mostrarMensajeSeccionNoDisponibles('APORTACIONES')" v-else>
              &nbsp;1 | <i class="bi bi-currency-dollar"></i>
              <strong>
                Aportaciones
              </strong>
              <div>
                <small>
                  Aqui puedes descargar tu referencia de aportación y cargar tus comprobantes.
                </small>
              </div>
            </div>        

          </section>

          <section v-if="cursoData.c41!='C'">

            <div class="btn btnBlue fullWidth row" @click="displayEncuesta()" style="margin-top:5px;" v-if="cursoData.c36!='-'">
              &nbsp;2 | <i class="bi bi-card-checklist"></i>
              <strong>
                Registro de Encuesta de Satisfacción
              </strong>
              <div>
                <small>
                  Aqui puedes registrar tu encuesta de satisfacción.
                </small>
              </div>
            </div>

            <div class="btn btnDefault fullWidth row" style="margin-top:5px;" @click="mostrarMensajeSeccionNoDisponibles('ENCUESTA')" v-else>
              &nbsp;2 | <i class="bi bi-card-checklist"></i>
              <strong>
                Registro de Encuesta de Satisfacción
              </strong>
              <div>
                <small>
                  Aqui puedes registrar tu encuesta de satisfacción.
                </small>
              </div>
            </div>

          </section>
          
          

          <section v-if="cursoData.c41!='C'">
            
            <div :class="'btn '+cursoData.c3=='P'?'btnOrange':'btnBlue'+' fullWidth row'" @click="getConstancia(cursoData.c36,(''+$root.fechaToStr($root.getTimeStamp())))" v-if="cursoData.c36!=='-'&&encuestaRegistrada==1" style="margin-top:5px;">
              &nbsp;3 | <i class="bi bi-download"></i>
              <strong>
                Descargar Constancia
              </strong>
            </div>
  
            <div class="btn btnDefault fullWidth row" @click="showMensajeConstanciaNoLiberada()" v-else style="margin-top:5px;">
              &nbsp;3 | <i class="bi bi-download"></i>
              <strong>
                Descargar Constancia
              </strong>
            </div>
          </section>
          <section v-else>

            <div :class="'btn '+cursoData.c3=='P'?'btnOrange':'btnBlue'+' fullWidth row'" @click="getConstancia(cursoData.c36,(''+$root.fechaToStr($root.getTimeStamp())))" v-if="cursoData.c36!=='-'" style="margin-top:5px;">
              &nbsp;1 | <i class="bi bi-download"></i>
              <strong>
                Descargar Constancia
              </strong>
            </div>
  
            <div class="btn btnDefault fullWidth row" @click="showMensajeConstanciaNoLiberada()" v-else style="margin-top:5px;">
              &nbsp;1 | <i class="bi bi-download"></i>
              <strong>
                Descargar Constancia
              </strong>
            </div>

          </section>

        </section>


          <!--
          <div class="btn btnDefault col48 row" @click="userStore.carritoCursos[userStore.carritoCursos.length]=cursoData;">
            <i class="bi bi-cart-plus-fill"></i>
            <small>
              Agregar al Carrito
            </small>
          </div>
          <div class="btn btnBlue col95 row" @click="setSelectedInscripcion()">
            <i class="bi bi-pencil-square"></i>Inscribirme
          </div>
          -->
        </div>


      

      <!--
      <div class="formRow col90 center glass tCenter">
    
        <div class="formRow colSm95" v-if="procesando==0">
          
          <button class="btn primary btnWide" 
          >Registrar</button>
                
        </div>
        
      </div>
      -->

    </div>


    <modal title="Referencia de aportación" v-if="showModalReferencia" v-on:closeModalEv="closeReferenciaModal()" style="display:block;left:10vw;top:10vh;height:30vh;">
      <div style="text-align:center;overflow-y:auto;">    
        
        
        <a class="btnOrange fullWidth center" download="referencia de aportacion.pdf" :href="docSrc" style="color:white;text-decoration: none;margin-top:20px;margin-bottom:20px;">
          <i class="bi bi-download"></i>
          Descargar Referencia
        </a>
        

        <iframe 
        :src="docSrc" 
        class="fullWidth" 
        style="max-height:60vh;height:70vh;"
        ></iframe>


      </div>
    </modal>



    <modal title="Mensaje" v-if="showModal" v-on:closeModalEv="closeModal()" style="display:block;left:10vw;top:10vh;height:30vh;">
      <div style="text-align:center;overflow-y:auto;">
        <h3 style="color:black;">

          {{modalMessage}}
          
        </h3>
        
      </div>
      
    </modal>

    <modal :title="modalTitle" v-if="showFileModal" v-on:closeModalEv="closeFileModal()" style="position:fixed;display:block;left:10vw;top:10vh;height:30vh;z-index:1000;" :interno="true">
      
      <div style="text-align:center;overflow-y:auto;" v-if="modalView=='MSG'">
        <h3 style="color:black;">

          {{modalMessage}}
          
        </h3>
        
      </div>

      <div class="fullWidth" style="text-align:center;overflow-y:auto;max-height:70vh;overflow-x:hidden;" v-if="modalView=='IMG'">
        <div class="col95 block center tCenter">
          <!--
          Ruta:{{fileSrc}}
          -->
          <strong style="font-size:1.5rem;color:black;">
            Esta a punto de cargar el siguiente archivo. ¿Es Correcto?            
          </strong>
          <div class="fullWidth">
            <div class="col90 center" v-if="userStore.loadingFile.extension=='.jpg'" style="max-height:50dvh;overflow-y: auto;">
              <img class="col80 colSm95" :src="fileSrc" style="object-fit: cover;">
            </div>
            <iframe 
            :src="(fileSrc+'#toolbar=1')" 
            class="col95" 
            style="max-height:40vh;height:50vh;"
            v-if="userStore.loadingFile.extension=='.pdf'"
            ></iframe>
          </div>

        </div>
        <div class="col95 block center">
          <button class="btnBlue col45 row" @click="sendFormData()">
            Continuar carga del archivo
          </button>
          <button class="btnError col45 row" @click="closeFileModal()">
            Cancelar la carga del archivo
          </button>

        </div>
        
      </div>      
      
    </modal>


  </div>
</template>

<script>

import axios from 'axios';
import { mapStores } from 'pinia';
import { useUserStore } from '../../store/user';
import Modal from '../Modal/Modal.vue';
import RegistroEncuesta from './VistasAccion/RegistroEncuesta.vue';



export default {
  name: 'VistaEstadoCurso',
  components:{Modal,RegistroEncuesta},
  props:{
    cursoData:Object
  },
  data:function(){
    return{

      showCursoData:false,

      showModalReferencia:false,
      docSrc:'',
      encuestaRegistrada:false,
      cargando:0,
      showModal:false,
      modalMessage:'',
      vista:'',
      fileName:'',
      listaAportaciones:[
        {
          c0:'folio',
          c1:'fecha',
          c2:'banco',
          c3:'monto',
          c4:'rutaArchivo'
        },
      ],
      fileSrc:'',
      showFileModal:false,
      modalView:'IMG',
      modalTitle:'Carga de Archivos'
    }
  },
  mounted:function(){

    this.encuestaRegistrada = this.cursoData.c29;

  },
  watch:{

    vista:function(){
      if(this.vista=='APORTACIONES'){
        this.getListaPagosAlumno();
      }
    }

  },
  methods:{

    getObservacionClass(estadoVal){

      let classesObj = {
        'N':'default',
        'R':'blueDark',
        'O':'comment',
        'C':'correct'
      };

      return classesObj[''+estadoVal];

    },

    updateEstadoEncuesta(val){

      this.encuestaRegistrada = val;

    },

    displayEncuesta(){

      if(this.cursoData.c36!='-'&&this.cursoData.c29==0){
        
        this.vista='ENCUESTA';

      }else{

        let str = "Ya has realizado tu encuesta."

        this.mostrarMensaje(str);

      }

    },

    closeVista(){

      this.vista = '';

    },


    mostrarMensajeSeccionNoDisponibles(estado){

      let str = "Por el momento esta sección no esta disponible para este curso. Por favor espera a que sea habilitada."

      if(estado=='APORTACIONES'){
        str = "Cupo no alcanzado. Una vez que el cupo sea alcanzado podrás descargar tu referencia de aportación y cargarla en esta sección. Un asesor educativo indicará el inicio de este proceso.";
      }

      if(estado=='ENCUESTA'){
        str = "La encuesta no se encuentra disponible. Un asesor educativo indicará cuando la encuesta pueda ser realizada.";
      }


      this.mostrarMensaje(str);

    },


    mostrarMensaje(msg){

      this.showModal = true;
      this.modalMessage = msg;

    },

    closeReferenciaModal(){

      this.showModalReferencia = false;

    },


    closeModal(){

      this.showModal = false;

    },


    getReferenciaStr(){
      console.log("getReferenciaStr()");      
      let data = {
        key:''+this.cursoData.c0
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/genReferenciaPago/",
        data,
        this.onSuccessGetReferenciaStr
      );
    },
    onSuccessGetReferenciaStr(data){
      console.log("onSuccessGetReferenciaStr:");
      console.log(data);

      this.docSrc = data.base64;
      this.showModalReferencia = true;
      
    },



    getListaPagosAlumno(){
      console.log("getListaPagosAlumno()");      
      let data = {
        key:''+this.cursoData.c0
      };

      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaPagosAlumnos/",
        data,
        this.onSuccessGetListaPagosAlumnos
      );
    },
    onSuccessGetListaPagosAlumnos(data){
      console.log("onSuccessGetListaPagosAlumnos:");
      console.log(data.data.data);
      this.setListaAportaciones(data.data.data);
    },
    setListaAportaciones(data){

      this.listaAportaciones = data;

    },

    sendUpdateRegistroAportacionAl(keyAp){
      console.log("sendUpdateRegistroAportacionAl()");      
      let data = {
        //id :''+this.cursoData.c0,
        //idh:''+this.cursoData.c1,

        id:''+this.userStore.idAlCur,
        idIns:''+this.cursoData.c0,
        idAp:''+keyAp,
        tam:''+this.userStore.loadingFile.fileSizeMB

      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/updateRegistroAportacionAl/",
        data,
        this.onSuccessSendUpdateRegistroAportacionAl
      );
    },
    onSuccessSendUpdateRegistroAportacionAl(data){
      console.log("onSuccessSendUpdateRegistroAportacionAl:");
      console.log(data);
      console.log(data.key);

      if(data.insert=='ok'){
        this.sendGenComprobantePago(data.key);
      }
      if(data.update=='ok'){
        this.sendGenComprobantePago(data.key);
      }


    },

    sendFormData(){

      let file = this.userStore.loadingFile.file;
      console.log("sendFormData()");
      console.log(this.userStore.loadingFile.file);

      let formData = new FormData();

      formData.append("fileToUpload", file);
      formData.append("archivoSizeMb", 1);
      formData.append("extensionDeseada", this.userStore.loadingFile.extension);
      formData.append("folio", this.userStore.loadingFile.folio);
      formData.append("cursoFolio", this.cursoData.c38);
      formData.append("nombre",this.userStore.loadingFile.filename);
      formData.append("anio",this.userStore.anioRegistro);
      formData.append("mes",this.userStore.mes);

      console.log("formData:");
      console.log(formData);
      console.log("ext:");
      console.log(this.userStore.loadingFile.extension);

      this.uploadDocFile(formData);
    //this.userStore.registroNuevoCurso.imagenFormData = data;
    },

    sendGenComprobantePago(idAp){
      console.log("sendGenComprobantePago()");      
      let data = {
        id :''+this.cursoData.c0,
        idh:''+this.cursoData.c1,
        idAp:''+idAp
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/genComprobantePago/",
        data,
        this.onSuccessSendGenComprobantePago
      );
    },
    onSuccessSendGenComprobantePago(data){
      console.log("onSuccessSendGenComprobantePago:");
      console.log(data);

      this.getListaPagosAlumno();
      
    },



    async uploadDocFile(formData) {

      const uriServer = "https://sitioliceo.com/fstrCursos/uploadComprobanteFile.php";

        axios
          .post(uriServer, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            console.log(response.data);
            console.log(response.data.response_data.status);

            //this.cargando=0;
            let strExito=response.data.response_data.msg;
            console.log("response.data.response_data.msg:");
            console.log(response.data.response_data.msg);


            if (response.data.response_data.status == 1) {

              this.sendUpdateRegistroAportacionAl(''+this.userStore.loadingFile.key);

              this.resultadoCarga = response.data.response_data.status;
              this.modalView = 'MSG';
              this.modalMessage = strExito;
              
            }else{

              alert("Error: "+strExito);

            }

            console.log("SUCCESS");
          })
          .catch(error => {
            console.log(error);
          });

    },


    closeFileModal(){

      this.showFileModal = false;

    },

    displayFileModal(){

      this.fileSrc = this.userStore.loadingFile.fileSrc;
      this.showFileModal=true;
      this.modalView='IMG';
      this.modalTitle='Carga de Archivos';

    },

    handleFileDoc(uploadingFileName,extension,fileInputId,inputFileEnLista,key){

      this.userStore.loadingFile = {
        fileSrc:'',
        filename:''+uploadingFileName,
        extension:''+extension,
        folio:''+this.userStore.idAlCur,
        file:null,
        key:''+key
      };

      /*
      console.log("handleFileDoc:");
      console.log("this.userStore.loadingFile:");
      console.log(this.userStore.loadingFile);
      */

      this.cargando = 1;
      console.log("HandleFileDoc:");

      this.$forceUpdate();

      //console.log("Nombre Doc: cursoImagenUploadRef");

      /*
      console.log(this.$refs);
      console.log("IputRef:");
      console.log(this.$refs[''+fileInputId+'Ref']);
      console.log("InputRefValue:");
      console.log(this.$refs[''+fileInputId+'Ref'].value);

      console.log("Archivo: ");
      console.log(this.$refs[''+fileInputId+'Ref']);
      console.log(this.$refs[''+fileInputId+'Ref'].files);
      console.log(this.$refs[''+fileInputId+'Ref'].files[0]);
      */

      console.log("fileInputIdRef:");
      console.log(fileInputId+'Ref:');
      console.log(this.$refs[''+fileInputId+'Ref']);

      console.log("refs:");
      console.log(this.$refs);

      let file = null;

      if(inputFileEnLista){

        console.log("EnLista");
        file = this.$refs[''+fileInputId+'Ref'][0].files[0];

      }else{

        console.log("Externo");
        file = this.$refs[''+fileInputId+'Ref'].files[0];

      }


      console.log("File:");
      console.log(file);

      console.log("FileSize:");
      console.log(file.size);

      let tamArchSeleccionado = (file.size/1048576);
      console.log("FileSizeMB:");
      console.log( tamArchSeleccionado );

      console.log("FileName:");
      console.log( file.name );
      let fileName=file.name;
      let ext=(fileName.substring(fileName.lastIndexOf("."))).toLowerCase();
      console.log(ext);

      let tamMaxPermitido = parseFloat('1.0');
      console.log("Tam en MB"+tamArchSeleccionado+"<"+tamMaxPermitido);

      /*
      ||
        (extension=='.jpg'?(ext=='.jpg'||ext=='.jpeg'||ext=='.JPG'||ext=='.JPEG'):false)
      */

      if(
        extension==ext||
        (extension=='.jpg'?(ext=='.jpg'||ext=='.jpeg'||ext=='.JPG'||ext=='.JPEG'):false)
      ){

        if(tamArchSeleccionado<tamMaxPermitido){
        
          //''+this.userStore.idAlCur+this.cursoData.c38+'pago'
          this.userStore.loadingFile.filename = 'aportacion';
          this.userStore.loadingFile.fileSizeMB = tamArchSeleccionado;

          this.setFile(file);
          this.cargando = 0;
          //this.uploadDocFile(formData);
        }else{

          this.showModal=true;
          this.modalMessage=''+"El archivo no se pudo cargar. El limite de tamaño de archivo permitido para este tipo de documento es de "+tamMaxPermitido+" MByte(s), Por favor reduzca el tamaño del archivo e intente nuevamente";
          this.cargando=0;
          //this.$refs[fileInputId+'Ref'].value="";

          if(inputFileEnLista){
            console.log("EnLista");
            file = this.$refs[''+fileInputId+'Ref'][0].value="";
          }else{
            console.log("Externo");
            file = this.$refs[''+fileInputId+'Ref'].value="";
          }

        }
      }else{

        this.showModal=true;
        this.modalMessage=''+"Error: "+"El tipo de Archivo seleccionado: "+ext+" no concuerda con el tipo especificado: .pdf";
        
        this.cargando=0;
        //this.$refs[fileInputId+'Ref'].value="";

        if(inputFileEnLista){
            console.log("EnLista");
            file = this.$refs[''+fileInputId+'Ref'][0].value="";
        }else{
            console.log("Externo");
            file = this.$refs[''+fileInputId+'Ref'].value="";
        }

      }

    },

    setPictureData(data){
      /*
      console.log("setPictureData():");
      console.log(data);
      console.log(data.target.result);
      */
      //this.fileSrc = data.target.result;
      this.userStore.loadingFile.fileSrc = data.target.result;
      //this.$emit('showFileModalEv');
      this.displayFileModal()
    },

    setFile(file){

      console.log("setFile()");
      console.log("File:");
      console.log(file);
      let fr = new FileReader();
      //let srcStr = 'unset';
      fr.onload = this.setPictureData;
      /*
      console.log("srcStr");
      console.log(srcStr);
      */
      this.userStore.loadingFile.file = file;
      fr.readAsDataURL(file);

    },


    getConstancia(key,dateStr){

      let link='https://www.sitioliceo.com/scLCcur/api/superSC/v1/constancia.php?id='+key+'&fecha='+dateStr;
      window.open(link);

    },

    showMensajeConstanciaNoLiberada(){
      let msgParam={
        title:'Constancia No Disponible',
        msg:'La constancia no se encuentra disponible, podrá descargarse cuando el curso haya finalizado y realice la encuesta de satisfacción.'
      };

      this.showModal = true;
      this.modalTitle = msgParam.title;
      this.modalMessage = msgParam.msg;

      //this.$emit('showMensajeEv',msgParam)
    },

    setSelected(){

      this.$emit('setSelectedCursoEv');


    }


  },
  computed:{
    ...mapStores(useUserStore),
  }
  
  

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@keyframes jello {
  11.1% {
    transform: none
  }
  22.2% {
    transform: skewX(-5.5deg) skewY(-5.5deg)
  }
  33.3% {
    transform: skewX(4.25deg) skewY(4.25deg)
  }
  44.4% {
    transform: skewX(-2.525deg) skewY(-2.525deg)
  }
  55.5% {
    transform: skewX(1.3625deg) skewY(1.3625deg)
  }
  66.6% {
    transform: skewX(-0.78125deg) skewY(-0.78125deg)
  }
  77.7% {
    transform: skewX(0.390625deg) skewY(0.390625deg)
  }
  88.8% {
    transform: skewX(-0.1953125deg) skewY(-0.1953125deg)
  }
  100% {
    transform: none
  }
}


@keyframes jello2 {
  11.1% {
    transform: none
  }
  22.2% {
    transform: skewX(-5.5deg) skewY(-5.5deg)
  }
  
  33.4% {
    transform: skewX(-2.525deg) skewY(-2.525deg)
  }
  55.5% {
    transform: skewX(1.3625deg) skewY(1.3625deg)
  }
  
  77.7% {
    transform: skewX(0.390625deg) skewY(0.390625deg)
  }
  88.8% {
    transform: skewX(-0.1953125deg) skewY(-0.1953125deg)
  }
  100% {
    transform: none
  }
}


.center {
  display: inline-block
}

.jello {
  animation: jello 1.5s ease;
  transform-origin: center
}




</style>
